import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, ButtonBase, InputBase, useTheme,List, ListItem, ListItemButton, } from "@mui/material";
import cx from 'classnames';
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MSelectWorkspaces from "../../../components/global/Modals/MSelectWorkspaces";
import Shbutton from "../../../components/theme/buttons/Shbutton";
import ShLabel from "../../../components/theme/label/ShLabel";
import SelectGroup from "../../../components/theme/Select/SelectGroup";
import Subheading from "../../../components/theme/text/Subheading";
import Text from "../../../components/theme/text/Text";
import { useTopbar } from "../../../contexts/TopbarProvider";
import { setWorkSpace, updateMenuState } from '../../../newapi/global/settingsSlice';
import { useGetInboundByBarcodeToProcessMutation, useGetInboundsToProcessQuery, useGetInboundToProcessMutation } from "../../../newapi/inbound/inboundsSlice";
import { useFindWorkspacesSelectQuery } from "../../../newapi/warehouse/workspaceSlice";
import { tokens } from "../../../theme";
import { getInboundStateData } from "../../../utils/labelColorText";
import { general_states } from "../../../utils/staticEnums";
import InboundToProcessView from './views/InboundToProcessView';
import { useGetSettingsQuery } from '../../../newapi/global/generalApiSlice';
import { ReactComponent as BarcodeSvg } from "../../../styles/svg/barcode.svg";
import PopoverModal from '../../../components/theme/Modal/PopoverModal';
import DropOut from '../../../components/theme/dropout/DropOut';
import { t } from 'i18next';
import { useGetRelationsSelectQuery } from '../../../newapi/global/relation/relationSlice';
import { useInView } from 'react-intersection-observer';

const ProcessInbound = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const dispatch = useDispatch();
    const [showInboundToProcess, setShowInboundToProcess] = useState(false);
    const [scannedValue, setScannedValue] = useState('none');
    const [highlightColor, setHighlightColor] = useState('none');
    const [incData, setIncData] = useState();
    const { showExtraComponent, clearExtraComponent,showExtraTitle,clearExtraTitle } = useTopbar();
    const { data: inboundSettings} = useGetSettingsQuery("inbound");
    const dimensionsAndWeightRequired = inboundSettings?.find(setting => setting.key === 'inbound_dimension_and_weight_required')?.value === "true";
    const carrierRequired = inboundSettings?.find(setting => setting.key === 'inbound_carrier_required')?.value === "true";
    // useBlockExternalNavigation(isBlocking);
  
    // // // Block internal navigation (clicking on links, using navigate())
    // useBlockInternalNavigation(isBlocking);


    const resetWorkspace = () => {
        dispatch(setWorkSpace({
            id: -1,
            name: "workspace_not_set"
        }))
    }

    const [open, setOpen] = useState(false);
    const workSpaceModal = {
        open: open,
        setOpen: setOpen
    }
    const [multipleOrders, setMultipleOrders] = useState(null);


    // Use mutation instead of query
    // const { data: inboundSettings} = useGetSettingsQuery("echeck");
    // const autoFinalize = inboundSettings?.find(setting => setting.key === 'echeck_auto_finalize')?.value === "true";
    // const carrierMandatory = inboundSettings?.find(setting => setting.key === 'echeck_carrier_mandatory')?.value === "true";

    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const [filterObject,setFilterObject] = useState({});

    const {data: jobsData, isLoading: jobsLoading, isFetching:jobsFetching,refetch: refetchJobs} = useGetInboundsToProcessQuery({
        workspaceId: selectedWorkSpace.id,
        body: filterObject,
    },{skip: !selectedWorkSpace || showInboundToProcess, pollingInterval:60000});

    // Supplier filter options come from the inbounds on the list. While a supplier filter is active the list
    // only holds those suppliers, so the options are kept from the last fetch without a supplier filter.
    const [supplierOptions, setSupplierOptions] = useState([]);
    useEffect(() => {
        if (!jobsData || filterObject.suppliers?.length) return;

        const suppliers = new Map();
        jobsData.forEach((item) => {
            if (item.supplierId > 0 && !suppliers.has(item.supplierId)) {
                suppliers.set(item.supplierId, { id: item.supplierId, name: item.supplier });
            }
        });
        setSupplierOptions([...suppliers.values()].sort((a, b) => a.name.localeCompare(b.name)));
    }, [jobsData, filterObject.suppliers]);

    // const [getMyJob, {data: individualJob, isLoading: invididualJobLoading}] = useFindPickingJobMutation();
    const [getInboundById, {data: individualInbound, isLoading: invididualInboundLoading}] = useGetInboundToProcessMutation();
    const [getInboundByBarcode, {data: individualBarcodeInbound, isLoading: invididualInboundBarcodeLoading}] = useGetInboundByBarcodeToProcessMutation();

    const [stateVisibility, setStateVisibility] = useState({
        [general_states.FULLYRECEIVED]: false, // Initially echeck is hidden
        [general_states.PARTLYRECEIVED]: true, // Show completed by default
        [general_states.ACTIVE]: true, // Show in_progress by default
      });

    const stateOrder = [general_states.FULLYRECEIVED, general_states.PARTLYRECEIVED, general_states.ACTIVE];  // Define the desired order of states

    // Grouping based on state
    const groupedData = useMemo(() => {
        return jobsData?.reduce((acc, item) => {
            // Check if the state group exists, if not, create an empty array for that state
            if (!acc.groups[item.state]) {
                acc.groups[item.state] = [];
            }

            // Push the item to the appropriate state group
            acc.groups[item.state].push(item);

            // If the state is not already in the secondary array, push it
            if (!acc.states.includes(item.state)) {
                acc.states.push(item.state);
            }

            return acc;
        }, { groups: {}, states: [] });
    }, [jobsData]);


    // Sort states based on the predefined order (you can modify it according to your needs)
    const sortedStates = groupedData?.states.sort((a, b) => {
        return stateOrder.indexOf(a) - stateOrder.indexOf(b);
    });


    useEffect(() => {
        // Example: show different components based on user privileges
        if(selectedWorkSpace !== null && selectedWorkSpace.id > -1){
            showExtraComponent(
                <Box
                    className={cx('',{
                        'not-selected': selectedWorkSpace === null,
                        // 'not-selected': p,
                    })}
                    sx={{
                        height:40,
                        background:theme.palette.mode === "dark" ? colors.blue[800] : colors.primary[400],
                        borderRadius:5,
                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                        fontSize:14,
                        fontWeight:"bold",
                        fontFamily:"Roboto, sans-serif",
                        lineHeight:"40px",
                        px:2,
                        "&.not-selected" : {
                            background:colors.red[400],
                            animation: 'pulse 1.5s infinite',
                            '@keyframes pulse': {
                                '0%': {
                                    transform: 'scale(1)',
                                },
                                '50%': {
                                    transform: 'scale(1.2)',
                                },
                                '100%': {
                                    transform: 'scale(1)',
                                },
                            },
                        },
                        "@media screen and (max-width: 1024px)" : {
                            display:"none"
                        }
                    }}
                >
                    {selectedWorkSpace !== null ? selectedWorkSpace.name : t("no_selection")}
                </Box>
            );
        }
  
        return () => {
            clearExtraComponent();
        };
    }, [selectedWorkSpace]);

    useEffect(() => {
        showExtraTitle(t("process_inbounds"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    
    useEffect(() => {
        if(window.innerWidth > 1369){
            dispatch(updateMenuState(true));
        }
    },[])
    
    const handleGetPickingJobOrOrderToEcheck = async (e) => {
        if (e.key === 'Enter') {
            getInboundByBarcode(e.target.value)
            .unwrap()
            .then(result => {
                setScannedValue(e.target.value);
                if(!result['multiple']){
                    setIncData(result['object']);
                    setShowInboundToProcess(true);
                } else {
                    setMultipleOrders(result['object']);
                }
            })
            .catch(error => {
                console.error("index 187", error);
                setHighlightColor('red');
                toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
        }
    }

    const getInboundOnclick = async (id) => {
        if(invididualInboundLoading) return;

       await getInboundById(id).unwrap()
        .then(result => {
            setIncData(result);
            setScannedValue("");
            setShowInboundToProcess(true);
            setMultipleOrders(null);
        })
        .catch(error => {
            console.error("index 213",error);
            setHighlightColor('red');
            toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    useEffect(() => {
        if (highlightColor !== 'none') {
            setTimeout(() => setHighlightColor('none'), 500); // Duration to stay colored
        }
    }, [highlightColor]);

    useEffect(() => {
        if(!showInboundToProcess) {
            refetchJobs();
        }
    },[showInboundToProcess])


    const goBack = () => {
        setScannedValue(null);
        setShowInboundToProcess(false);
    }

    const getBackgroundColor = () => {
        switch (highlightColor) {
            case 'orange':
                return colors.orange[400];
            case 'green':
                return colors.green[400];
            case 'red':
                return colors.red[400];
            default:
                return 'initial'; // or your default color
        }
    };
    
    const [searchValue, setSearchValue] = useState("");

    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;

    const handleFilterPopoverClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };

    const handleFilterPopoverClose = () => {
        setFilterAnchorEl(null);
        // setExportAnchorEl(null);
    };

    return (
        <Box 
            height={1} 
            display={"flex"} 
            width={1} 
            gap={4} 
            paddingX={4} 
            paddingTop={13} 
            overflow={"auto"}
            sx={{
                // overflow:"hidden",
                "@media screen and (max-width: 47.9375em)" : {
                    
                },
                background: getBackgroundColor(), // You can use your original color instead of 'initial' if needed
                transition: 'background-color 0.5s'
            }}
        >

            {/* List content body */}
            {!showInboundToProcess &&
                <Box
                    sx={{
                        flex:1,
                        display:"flex",
                        gap:4,
                    }}
                >
                    <Box
                        sx={{
                            width:480,
                            overflow:"hidden",
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:'center',
                                pb:1,
                            }}
                        >
                            <Subheading>{t("to_process")}</Subheading>

                            {selectedWorkSpace.id !== -1 &&
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:2,
                                    }}
                                >
                                    <ButtonBase
                                        onClick={() => {workSpaceModal.setOpen(true)}}
                                        sx={{
                                            height:32,
                                            px:2,
                                            borderRadius:4,
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                            border:`1px solid ${colors.grey[100]}`,
                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                            color: colors.txt["primary"],
                                            fontWeight:500,
                                            fontSize:14,
                                            fontFamily:"Roboto, sans-serif"
                                        }}
                                    >
                                        {selectedWorkSpace.name}

                                    </ButtonBase>

                                    <ButtonBase
                                        disabled={jobsLoading}
                                        onClick={refetchJobs}
                                        sx={{
                                            height:32,
                                            width:32,
                                            borderRadius:4,
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                            display:"flex",
                                            alignItems:"center",
                                            justifyContent:"center"
                                        }}
                                    >
                                        <RefreshIcon/>

                                    </ButtonBase>
                                </Box>
                            }
                        </Box>

                        <Box
                            sx={{
                                display:"flex",
                                gap:1.5,
                                mt:2,
                            }}
                        >
                            {stateOrder.map((state, idx) => (
                                <ShLabel
                                    onClick={() => {
                                        setStateVisibility((prevState) => ({
                                          ...prevState,
                                          [state]: !prevState[state],  // Toggle the visibility of the clicked state
                                        }));
                                    }}
                                    variant={stateVisibility[state] ? getInboundStateData(state,theme)?.labelcolor : theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                    key={idx}
                                    clickable
                                    fitted
                                    borderless
                                    size={32}
                                    palette="normal"
                                >

                                    {t(getInboundStateData(state,theme).labeltext)}
                                </ShLabel>
                            ))}
                        </Box>

                        <Box
                            sx={{
                                mt:2,
                                display:'flex',
                                background:theme.palette.mode === 'dark' ? colors.grey[400] : colors.grey[100],
                                borderRadius:4,
                                pr:0.5,
                                height:32,
                                alignItems:'center',
                            }}
                        >
                            <InputBase 
                                placeholder={t("search_reference")}
                                value={searchValue}
                                onChange={(e) => {
                                    setSearchValue(e.target.value);
                                }}
                                sx={{
                                    px:2,
                                    flex:1,
                                    color:colors.txt['primary'],
                                    fontSize:14,
                                    fontFamily:"Roboto,sans-serif"
                                }}
                            />

                            <ButtonBase
                                onClick={handleFilterPopoverClick}
                                sx={{
                                    height:24,
                                    borderRadius:4,
                                    background:theme.palette.mode === "dark" ? colors.txt['secondary'] : colors.grey[400],
                                    color:theme.palette.mode === "dark" ? colors.txt['primary'] : colors.txt['light'],
                                    px:1.5,
                                }}
                            >
                                {t("filter")}
                            </ButtonBase>

                        </Box>

                        {selectedWorkSpace.id !== -1 &&
                            <Box
                                sx={{
                                    height:"calc(100% - 162px)",
                                    overflow:'auto',
                                    mt:3,
                                }}
                            >
                                {groupedData && groupedData.groups &&
                                    sortedStates.map((state) => (
                                        <Box key={state}
                                            sx={{
                                                display: stateVisibility[state] ? 'block' : 'none', // Hide/show based on visibility
                                            }}
                                        >
                                            <Text bold variant={getInboundStateData(state,theme).labelcolor}>
                                                
                                                {t(getInboundStateData(state,theme).labeltext)}
                                            </Text>
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    flexDirection:"column",
                                                    gap:1.5,
                                                    mb:3,
                                                    mt:1,
                                                }}
                                            >
                                                {groupedData.groups[state]
                                                    .filter((item) => {
                                                        return filterObject.relations != null && filterObject.relations.length !== 0 ? filterObject.relations.includes(item.relationId) : true;
                                                    })
                                                    .filter((item) => {
                                                        return filterObject.suppliers != null && filterObject.suppliers.length !== 0 ? filterObject.suppliers.includes(item.supplierId) : true;
                                                    })
                                                    .filter((item) => {
                                                        if (!searchValue) return true;

                                                        const search = searchValue.toLowerCase();

                                                        return (
                                                            item.barcode?.toLowerCase().includes(search) ||
                                                            item.reference?.toLowerCase().includes(search)
                                                        );
                                                }).map((item) => (
                                                    <ButtonBase
                                                        disabled={invididualInboundLoading}
                                                        key={"item"+item.id}
                                                        onClick={() => {
                                                            getInboundOnclick(item.id);
                                                            // getPickingJob(item.id);
                                                        }}

                                                        sx={{
                                                            display:'flex',
                                                            flexDirection:"column",
                                                            alignItems:"flex-start",
                                                            gap:3,
                                                            boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                            border:`1px solid ${colors.grey[100]}`,
                                                            p:2,
                                                            borderRadius:4,
                                                            background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0]
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display:'flex',
                                                                justifyContent:"space-between",
                                                                alignItems:"flex-start",
                                                                width:1,

                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    flexDirection:"column",
                                                                    // justifyContent:"space-between",

                                                                }}
                                                            >
                                                                <Text black>
                                                                    {item.relation}
                                                                </Text>
                                                                <Text>
                                                                    {item.barcode}{item.reference && item.reference !== "" && ` (${item.reference})`}
                                                                </Text>
                                                               
                                                            </Box>
                                                            
                                                            <ShLabel
                                                                key={theme.palette.mode}
                                                                variant={getInboundStateData(state,theme).labelcolor}
                                                                clickable
                                                                fitted
                                                                size={32}
                                                                palette="normal"
                                                                borderless
                                                                sx={{
                                                                    flexShrink:0,
                                                                }}
                                                            >
                                                                {t(getInboundStateData(state,theme).labeltext)}
                                                                {/* {t(state)} */}
                                                            </ShLabel>
                                                        </Box>

                                                        <Box
                                                            sx={{
                                                                display:'flex',
                                                                gap:4,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    justifyContent:"flex-start",
                                                                    flexDirection:"column"
                                                                }}
                                                            >
                                                                <Text light>{t("sku_count")}</Text>
                                                                <Text bold>{item.skuCount}</Text>

                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    justifyContent:"flex-start",
                                                                    flexDirection:"column"
                                                                }}
                                                            >
                                                                <Text light>{t("expected")}</Text>
                                                                <Text>{new Date(item.shipmentDate).toLocaleDateString(i18n.language)}</Text>
                                                            </Box>
                                                        </Box>
                                                    </ButtonBase>
                                                ))}
                                            </Box>
                                        </Box>
                                    ))
                                }
                            </Box>
                        }

                        {selectedWorkSpace.id === -1 &&
                            <SelectWorkSpace/>
                        }
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.bg["tertiary"],
                            borderTopRightRadius: 16,
                            borderTopLeftRadius: 16,
                            display:"flex",
                            alignItems:'center',
                            position:'relative',
                            overflow:"hidden",
                        }}
                    >
                        {multipleOrders !== null &&
                            <Box
                                sx={{
                                    position:'absolute',
                                    // height:1,
                                    left:"16px",
                                    top:"16px",
                                    bottom:"16px",
                                    width:"300px",
                                    // height:1,
                                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                    px:3,
                                    py:2,
                                    overflow:"hidden",
                                    borderRadius:4,
                                    display:'flex',
                                    flexDirection:'column'
                                }}
                            >
                                <Subheading sx={{flexShrink:0,}}>{multipleOrders?.product.description}</Subheading>

                                <Box
                                    sx={{
                                        mt:2,
                                        display:"flex",
                                        flexDirection:'column',
                                        gap:1.5,
                                        overflow:'auto'
                                    }}
                                >

                                    {multipleOrders.inbounds.map((item) => (
                                        <ButtonBase
                                            disabled={invididualInboundLoading}
                                            key={"multiple-inbounds"+item.id}
                                            onClick={() => {
                                                getInboundOnclick(item.id);
                                                // getPickingJob(item.id);
                                            }}

                                            sx={{
                                                width:1,
                                                display:'flex',
                                                flexDirection:"column",
                                                alignItems:"flex-start",
                                                gap:3,
                                                boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                border:`1px solid ${colors.grey[100]}`,
                                                p:2,
                                                borderRadius:4,
                                                background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0]
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display:'flex',
                                                    justifyContent:"space-between",
                                                    alignItems:"flex-start",
                                                    width:1,

                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display:'flex',
                                                        flexDirection:"column",

                                                    }}
                                                >
                                                    <Text black>
                                                        {item.relation}
                                                    </Text>
                                                    <Text>
                                                        {item.barcode}{item.reference && item.reference !== "" && ` - ${item.reference}`}
                                                    </Text>
                                                    
                                                </Box>
                                                
                                            </Box>

                                            <Box
                                                sx={{
                                                    display:'flex',
                                                    gap:4,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display:'flex',
                                                        justifyContent:"flex-start",
                                                        flexDirection:"column"
                                                    }}
                                                >
                                                    <Text light>{t("expected")}</Text>
                                                    <Text>{new Date(item.date).toLocaleDateString(i18n.language)}</Text>
                                                </Box>
                                            </Box>
                                        </ButtonBase>
                                    ))}
                                </Box>

                            </Box>
                        }
                        <Box
                            sx={{
                                flex: 1,
                                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.bg["tertiary"],
                                borderTopRightRadius: 16,
                                borderTopLeftRadius: 16,
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: 3,
                                justifyContent: 'center',  // To center contents vertically
                                alignItems: 'center',      // To center contents horizontally
                                gap: 2 // Gap between items
                            }}
                        >

                            <Box
                                sx={{
                                    height:210,
                                    width:440,
                                    borderRadius:5,
                                    position:"relative",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200],
                                    border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[300]}`,
                                    "& .echeck-barcode-svg" : {
                                        height:150,
                                        width:"380px !important",
                                        animation: 'pulsate 2s infinite',
                                        "& path" : {
                                            fill: theme.palette.mode === "dark" ? colors.txt["secondary"] : "#8E96A7"
                                        }
                                    }
                                }}
                            >
    
                                <BarcodeSvg 
                                    className="echeck-barcode-svg"
                                />
                            </Box>
                            {/* <img 
                                src="/img/barcode.svg" 
                                alt="Barcode" 
                                style={{
                                    width: '30%', 
                                    height: '30%', 
                                    objectFit: 'contain',
                                    animation: 'pulsate 1.5s infinite'
                                }} 
                            /> */}

                            <Box display="flex"
                                height="32px"
                                // maxWidth="400px"
                                borderRadius="20px"
                                backgroundColor={colors.grey[100]}
                                sx={{
                                    marginTop:0.5,
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    }
                                }}
                            >
                                <InputBase sx={{ml: 2, flex:1, width: 248, textAlign: 'center', justifyContent: 'center'}} placeholder={t("scan_type_barcode")}
                                    onKeyDown={handleGetPickingJobOrOrderToEcheck}
                                    autoFocus={true}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }

            {showInboundToProcess && 
                <InboundToProcessView
                    dimensionsAndWeightRequired={dimensionsAndWeightRequired}
                    carrierRequired={carrierRequired}
                    firstScannedBarcode={scannedValue}
                    setHighlightColor={setHighlightColor}
                    incData={incData}
                    // autoFinalize={autoFinalize}
                    // carrierMandatory={carrierMandatory}
                    selectedWorkSpace={selectedWorkSpace}
                    goBack={goBack}
                    setIncData={setIncData}
                    setShowInboundToProcess={setShowInboundToProcess}
                    jobsLoading={jobsLoading}
                    jobsFetching={jobsFetching}
                    refetchJobs={refetchJobs}
                    getInbound={getInboundOnclick}
                />
                        
            }

            <MSelectWorkspaces
                open={workSpaceModal.open} 
                handleClose={() => workSpaceModal.setOpen(false)}
            />

            <FilterDropdown 
                id={filterPopoverId}
                open={filterPopoverOpen}
                anchorEl={filterAnchorEl}
                onClose={handleFilterPopoverClose}
                onChange={(values) => {
                    setFilterObject(values);
                }}
                showRelations={isFulfilment}
                supplierOptions={supplierOptions}
            />

        </Box>
    );
};

export default ProcessInbound;

const FilterDropdown = ({ showRelations, supplierOptions, ...props }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [filterObject, setFilterObject] = useState({})
    const [searchTerm, setSearchTerm] = useState("");
    const [displayCount, setDisplayCount] = useState(50);
    const {data, isLoading, isFetching} = useGetRelationsSelectQuery(undefined, { skip: !showRelations });
    
    const { ref, inView } = useInView({
        threshold: 1.0, 
    });
    useEffect(() => {
        if (inView && data && data?.length) {
            setDisplayCount((prev) => Math.min(prev + 50, data.length));
        }
    }, [inView, data,data?.length]);

    const filteredData = useMemo(() => {
        return data?.filter((item) =>
            item.name?.toLowerCase().includes(searchTerm.toLowerCase())
        ) || [];
    }, [data, searchTerm]);
        
    const visibleData = useMemo(() => {
        return filteredData?.slice(0, displayCount) || [];
    }, [filteredData, displayCount]);

    const handleStateToggle = (filterKey, item) => {
        setFilterObject(prev => {
            const currentState = Array.isArray(prev[filterKey])
                ? prev[filterKey]
                : [];

            const updatedState = currentState.includes(item)
                ? currentState.filter(i => i !== item)
                : [...currentState, item];

            // If first item is -1, remove filterKey entirely
            if (updatedState[0] === -1) {
                const { [filterKey]: _, ...rest } = prev;

                props.onChange(rest);
                return rest;
            }

            const nextState = {
                ...prev,
                [filterKey]: updatedState,
            };

            props.onChange(nextState);
            return nextState;
        });
    };

    return (
        <PopoverModal
            {...props}
            triangle={{position:"center",color:theme.palette.mode === "dark" ? colors.grey[300] : "#fff"}}
        >
            <Box
                sx={{
                    p:3,
                    pt:0,
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    width:400,
                }}
            >

                {showRelations &&
                <DropOut title={t("relation")} open>
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                            gap:1.5,
                        }}
                    >
                        <Box
                            sx={{
                                position:"sticky",
                                top:0,
                                zIndex:3,
                                width:1,
                                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                pb:1,
            
                            }}
                        >
                            <Box
                                sx={{
                                    height:32,
                                    width:1,
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    borderRadius:4,
                                    color:colors.txt['primary'],
                                    fontSize:14,
                                    display:"flex",
                                    alignItems:"center",
                                }}
                            >
                                <InputBase
                                    onKeyDown={(e) => {
                                        if(e.key === "Enter") {
                                            setSearchTerm(e.target.value);
                                        }
                                    }}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                    }}
                                    placeholder={t("search")}
                                    value={searchTerm}
                                    autoFocus
                                    sx={{
                                        // width:1,
                                        flex:1,
                                        height:32,
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                        borderRadius:4,
                                        px:2,
                                        color:colors.txt['primary'],
                                        fontSize:14,
                                    }}
                                />
                            </Box>
                        </Box>
                        <List
                            sx={{
                                padding:0,
                                display:"flex",
                                flexDirection:"column",
                                gap:1.5,
                                maxHeight:300,
                                overflow:'auto',
                            }}
                        >
                            {visibleData?.map((column, index) => (
                                <FilterListItem
                                    key={column.column + "indexrelation"+index}
                                    name={column.name}
                                    active={filterObject?.["relations"]?.includes(column.id)}
                                    onClick={() => handleStateToggle("relations",column.id)}
                                />
                            ))}

                            {/* This is the invisible trigger element */}
                            {visibleData?.length < data?.length && (
                                <div ref={ref} style={{ height: 1 }} />
                            )}
                        </List>
                    </Box>
                </DropOut>
                }

                <DropOut title={t("supplier")} open isLast>
                    <List
                        sx={{
                            padding:0,
                            display:"flex",
                            flexDirection:"column",
                            gap:1.5,
                            maxHeight:300,
                            overflow:'auto',
                        }}
                    >
                        {supplierOptions?.map((supplier) => (
                            <FilterListItem
                                key={"indexsupplier"+supplier.id}
                                name={supplier.name}
                                active={filterObject?.["suppliers"]?.includes(supplier.id)}
                                onClick={() => handleStateToggle("suppliers",supplier.id)}
                            />
                        ))}
                    </List>
                </DropOut>
            </Box>

        </PopoverModal>
    )
}

const FilterListItem = ({ name, active, onClick }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <ListItem disablePadding onClick={onClick}>
            <ListItemButton
                className={cx({
                    active: active
                })}
                sx={{
                    minWidth:250,
                    color:colors.txt["secondary"],
                    fontWeight:400,
                    display:"flex",
                    justifyContent:"space-between",
                    fontSize:"14px",
                    pl:2,
                    pr:0.5,
                    height:40,
                    borderRadius:5,

                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                    boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                    "&.active" : {
                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],

                    }
                }}
            >
                <Text>{name}</Text>
            </ListItemButton>
        </ListItem>
    )
}

const SelectWorkSpace = (props) => {
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const [selected, setSelected] = useState(-1);
    const [workTSpace,setTWorkSpace] = useState(selectedWorkSpace);

    const select = (selected) => {
        setTWorkSpace(data[selected]);
    }
    const { data: workSpaceData, isLoading } = useFindWorkspacesSelectQuery();

    useEffect(() => {
        if (!isLoading && workSpaceData) {
            const modifiedArray = workSpaceData.data.map(item => ({
                ...item,
                title: item.name
              }));
            
            setData(modifiedArray);
        }
    }, [workSpaceData, isLoading]);


    const selectWorkSpace = () => {
        dispatch(setWorkSpace({
            id:workTSpace.id,
            name:workTSpace.name,
        }));
    }

    useEffect(() => {
        if(data.length > 0) {
            for(var i = 0;i < data.length; i++) { 
                if(data[i].id === selectedWorkSpace.id){
                    setSelected(i);
                    // setSelected
                }
            }
        }
    }, [selectedWorkSpace,data]);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return(
        <Box
            sx={{
                mt:3,
                py:3,
                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                px:2,
                borderRadius:4,
            }}
        >
            
            <Box 
                sx={{
                    textAlign:"center",
                    // paddingY:4,
                    // paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{props.subheading || t("select_workspace")}</Subheading>
            </Box>
            <Box
                sx={{
                    pt:3,
                }}
            >
                <SelectGroup selected={selected} setSelected={select} options={data} />
            </Box>
            
            <Box
                sx={{
                    paddingTop:3,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} onClick={() => selectWorkSpace()} variant="contained">{t('select')}</Shbutton>
            </Box>
        </Box>
    )
}
